export default __webpack_public_path__ + "static/media/new-feature.3e8b423c.svg";